import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { AppIndexRoute, AppLayout, AppPageNotFound } from './components';
import { config } from '../../config';
import {
  MePaths,
  MeRouter,
  ProductsPaths,
  ProductsRouter,
  ProfilePaths,
  ProfileRouter,
  UsersPaths,
  UsersRouter,
} from '../../pods';
import { AgreementsPaths, AgreementsRouter } from '../../pods/agreements/agreements.router';
import { CompaniesPaths, CompaniesRouter } from '../../pods/companies';
import { DashboardPaths, DashboardRouter } from '../../pods/dashboard/dashboard.router';
import { DebugRoute } from '../../pods/debug/debug.route';
import { PortfolioPaths, PortfolioRouter } from '../../pods/portfolio/portfolio.router';
import { OnboardingApp } from '../onboarding-app';
import { AdminInviteRoute } from '../../pods/portfolio/admin/admin-invite.route';
import { ReportingPaths, ReportingRouter } from '../../pods/reporting/reporting.router';
import { EconomyPaths, EconomyRouter } from '../../pods/economy';
import { SingleTenantProtectedRoute } from '../../components/single-tenant-protected-route';

export function AppRoutes() {
  return (
    <Routes>
      {/* Onboarding wizard — rendered without navbar/sidebar */}
      <Route path={`${PortfolioPaths.Onboarding}`} element={<OnboardingApp />} />
      <Route path={`${PortfolioPaths.Onboarding}/invite`} element={<AdminInviteRoute />} />

      <Route element={<AppLayout />}>
        <Route index element={<AppIndexRoute />} />
        <Route path="*" element={<AppPageNotFound />} />
        <Route path={`${DashboardPaths.Dashboard}/*`} element={<DashboardRouter />} />
        <Route path={`${PortfolioPaths.Home}/*`} element={<PortfolioRouter />} />
        <Route path={`${AgreementsPaths.AgreementList}/*`} element={<AgreementsRouter />} />
        {/* <Route path={`${InvestmentsPaths.InvestmentList}/*`} element={<InvestmentsRouter />} /> */}
        <Route path={`${ReportingPaths.Home}/*`} element={<ReportingRouter />} />
        <Route
          path={`${EconomyPaths.Home}/*`}
          element={
            <SingleTenantProtectedRoute>
              <EconomyRouter />
            </SingleTenantProtectedRoute>
          }
        />
        <Route path={`${CompaniesPaths.Companies}/*`} element={<CompaniesRouter />} />
        <Route path={`${UsersPaths.Users}/*`} element={<UsersRouter />} />
        <Route path={`${ProfilePaths.Profile}/*`} element={<ProfileRouter />} />
        <Route path={`${MePaths.Me}/*`} element={<MeRouter />} />
        <Route path={`${ProductsPaths.Products}/*`} element={<ProductsRouter />} />
        {config.stage === 'local' && <Route path="/debug" element={<DebugRoute />} />}
      </Route>
    </Routes>
  );
}

export default AppRoutes;
